module.exports = __webpack_public_path__ + "static/Site-6-0ae3289e90c5ff6defda656463dc985c.jpg";